module.exports = __webpack_public_path__ + "img/img-error.9a8526bf.svg";